/** Fixed dark palette — photo session ignores app light/dark theme. */
export const photoSessionTheme = {
  bg: "#000000",
  surface: "rgba(255, 255, 255, 0.05)",
  surfaceMuted: "rgba(255, 255, 255, 0.08)",
  border: "rgba(255, 255, 255, 0.1)",
  text: "#fafafa",
  textMuted: "rgba(255, 255, 255, 0.55)",
  accent: "#f59e0b",
  accentHover: "#d97706",
  accentFg: "#0a0a0a",
  success: "#4ade80",
  error: "#f87171",
  overlay: "rgba(0, 0, 0, 0.88)",
} as const;

/** Root wrapper — isolate from document theme variables */
export const photoSessionRootClass =
  "photo-session-ui text-[#fafafa] bg-black [color-scheme:dark]";

/** Thumbnail strip — ~8% narrower/shorter than original */
export const photoSessionStrip = {
  verticalWidth: "4.75rem",
  horizontalHeight: "5.25rem",
  tileSize: "3.875rem",
} as const;
